module.exports = __webpack_public_path__ + "4a31ed35428024dc8cb463e439fc8f72.svg";